import { render, staticRenderFns } from "./ProductsRedesign.vue?vue&type=template&id=1b706460&"
import script from "./ProductsRedesign.vue?vue&type=script&lang=js&"
export * from "./ProductsRedesign.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRedesign.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports